import { AddDetails } from './add-details';

export * from './add-details';

export default AddDetails;
